<template>
  <div>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          x-small
          icon
          :color="hasSpecialAuthorization ? 'warning' : 'success'"
          @click.prevent="dialogHandle"
        >
          <v-icon>
            {{ hasSpecialAuthorization ? "mdi-file-replace" : "mdi-file-plus" }}
          </v-icon>
        </v-btn>
      </template>

      <span
        v-text="
          hasSpecialAuthorization
            ? 'Sustituir autorización especial'
            : 'Cargar autorización especial'
        "
      />
    </v-tooltip>

    <v-dialog v-model="dlg" scrollable persistent max-width="600px">
      <v-card tile :disabled="ldg" :loading="ldg">
        <v-toolbar dark dense>
          <v-toolbar-title> AUTORIZACIÓN ESPECIAL </v-toolbar-title>

          <v-spacer />

          <v-toolbar-items>
            <v-btn icon dark :disabled="ldg" @click="dlg = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-form ref="form" v-on:submit.prevent lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-spacer />
              </v-col>

              <v-col v-if="hasSpecialAuthorization" cols="12">
                <v-alert dense text type="info">
                  El reembolso ya cuenta con un documento de autorización
                  especial. Al guardar un nuevo archivo se sustituirá el
                  documento actual.
                </v-alert>
              </v-col>

              <v-col cols="12">
                <v-file-input
                  v-model="file"
                  label="Documento de autorización especial"
                  prepend-icon="mdi-paperclip"
                  show-size
                  dense
                  :rules="[(v) => !!v || 'Campo requerido.']"
                />
              </v-col>

              <v-col cols="12">
                <v-btn
                  block
                  small
                  color="success"
                  :loading="ldg"
                  @click.prevent="submit"
                >
                  {{
                    hasSpecialAuthorization
                      ? "Sustituir documento"
                      : "Guardar documento"
                  }}

                  <v-icon right> mdi-content-save </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import { URL_API, headersToken, msgAlert, msgConfirm } from "../control";

export default {
  props: {
    rsId: {
      type: Number,
      required: true,
    },
    hasSpecialAuthorization: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      log: this.$store.getters.getLogin,
      dlg: false,
      ldg: false,
      file: null,
    };
  },
  methods: {
    dialogHandle() {
      this.file = null;
      this.dlg = true;

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },
    submit() {
      if (!this.$refs.form.validate()) {
        this.$swal.fire(
          msgAlert(
            "error",
            "Formulario invalido, revisa los detalles señalados",
          ),
        );

        return;
      }

      this.$swal
        .fire(
          msgConfirm(
            this.hasSpecialAuthorization
              ? "¿Confirma sustituir el documento de autorización especial?"
              : "¿Confirma guardar el documento de autorización especial?",
          ),
        )
        .then((res) => {
          if (res.isConfirmed) {
            this.save();
          }
        });
    },
    save() {
      this.ldg = true;

      const form_data = new FormData();

      form_data.append("rs_id", this.rsId);
      form_data.append("document_special_authorization_0", this.file);

      Axios.post(
        URL_API + "/rss/refounds/special_authorization",
        form_data,
        headersToken(this.log.token),
      )
        .then((res) => {
          this.$swal.fire(
            msgAlert(res.data.success ? "success" : "error", res.data.message),
          );

          if (res.data.success) {
            this.dlg = false;
            this.file = null;

            this.$emit("updated");
          }
        })
        .catch((err) => {
          this.$swal.fire(
            msgAlert(
              "error",
              err.response && err.response.data
                ? err.response.data.message
                : "No fue posible guardar el documento",
            ),
          );
        })
        .finally(() => {
          this.ldg = false;
        });
    },
  },
};
</script>
